"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IStyleFunction.js.map